import qtAnalytics, { handleImpressions } from '../quote-tool/components/qtAnalytics';
import { aiUrl } from './apiProxy';

export default function ai() {
	// handle uploading photo
	let dashboardImageUpload = document.querySelector('#dashboardImageUpload');
	if (!dashboardImageUpload) return;

	let dashboardModal = document.querySelector('.c-modal--dashboard');

	let modalTooltip = dashboardModal.querySelector('.c-modal__tooltip');
	if (modalTooltip) {
		modalTooltip.addEventListener('click', function () {
			modalTooltip.classList.toggle('active');
		});
	}

	let steps = {
		info: 'c-modal__upload--info',
		start: 'c-modal__upload--start',
		verify: 'c-modal__upload--verify',
		uploading: 'c-modal__upload--uploading',
		services: 'c-modal__upload--services',
	};

	function resetModal() {
		let uploaderError = dashboardModal.querySelector('.c-modal__upload-status--error');
		if (uploaderError) {
			uploaderError.classList.remove('active');
		}

		let uploaderFailed = dashboardModal.querySelector('.c-modal__uploader.failed');
		if (uploaderFailed) {
			uploaderFailed.classList.remove('failed');
		}

		// Progress bar width to 1%
		let dashboardImageUploadProgress = dashboardModal.querySelector('#dashboardImageUploadProgress');
		if (dashboardImageUploadProgress) {
			dashboardImageUploadProgress.style.width = '1%';
		}

		let errorButtons = dashboardModal.querySelectorAll('.c-modal__upload-buttons--error.active');
		if (errorButtons.length > 0) {
			errorButtons.forEach((button) => button.classList.remove('active'));
		}

		let uploadSuccess = dashboardModal.querySelector('.c-modal__upload-status--success');
		if (uploadSuccess) {
			uploadSuccess.classList.remove('active');
		}
		let buttonSuccess = dashboardModal.querySelector('.c-modal__upload-buttons--success');
		if (buttonSuccess) {
			buttonSuccess.classList.remove('active');
		}

		let uploadStart = dashboardModal.querySelector('.c-modal__upload-status--uploading');
		if (uploadStart) {
			uploadStart.classList.add('active');
		}

		let uploader = dashboardModal.querySelector('.c-modal__uploader');
		if (uploader) {
			uploader.classList.remove('active');
		}

		dashboardModal.querySelector('.c-modal__upload--services').classList.remove('no-services');

		// Reset file input
		let dashboardImageUpload = dashboardModal.querySelector('#dashboardImageUpload');
		if (dashboardImageUpload) {
			dashboardImageUpload.value = '';
		}

		// Remove image preview
		let imagePreview = dashboardModal.querySelector('#dashboardImagePreview');
		if (imagePreview) {
			imagePreview.innerHTML = '';
		}

		// Reset file name and size display
		let uploadFileNameDashboard = dashboardModal.querySelector('#uploadFileNameDashboard');
		if (uploadFileNameDashboard) {
			uploadFileNameDashboard.innerHTML = '';
		}

		let uploadFileSizeDashboard = dashboardModal.querySelector('#uploadFileSizeDashboard');
		if (uploadFileSizeDashboard) {
			uploadFileSizeDashboard.innerHTML = '';
		}
	}

	function simulateRandomUpload() {
		// Add width to #dashboardImageUploadProgress to go to 96%
		let dashboardImageUploadProgress = dashboardModal.querySelector('#dashboardImageUploadProgress');
		let progress = 0; // Start from 0%
		const maxProgress = 96; // Maximum progress before stopping

		const uploadInterval = setInterval(() => {
			// Randomly increase progress by 1% to 5%
			const randomIncrease = Math.floor(Math.random() * 5) + 1;
			progress += randomIncrease;

			if (progress > maxProgress) {
				progress = maxProgress; // Ensure progress does not exceed maxProgress
			}

			dashboardImageUploadProgress.style.width = `${progress}%`;

			// Check if we've reached or exceeded the stopping point
			if (progress >= maxProgress) {
				clearInterval(uploadInterval); // Stop the simulated upload
			}
		}, 200); // Adjust time interval as needed
	}

	function openAiModal() {
		// add ai-modal-open on body
		document.body.classList.add('ai-modal-open-dashboard');
	}

	function closeAiModal() {
		document.body.classList.remove('ai-modal-open-dashboard');
		resetModal();
	}

	function sendImageForVerification() {
		// Key added server side by the site's proxy.
		const endpoint = aiUrl('dashboard');

		// Get the image element
		const imgElement = dashboardModal.querySelector('#dashboardImagePreview img');
		const imgSrc = imgElement.src;

		// Function to convert base64 to Blob
		function base64ToBlob(base64, type = 'application/octet-stream') {
			const binaryString = window.atob(base64.split(',')[1]);
			const len = binaryString.length;
			const bytes = new Uint8Array(len);
			for (let i = 0; i < len; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return new Blob([bytes], { type });
		}

		// Convert base64 image src to Blob
		const blob = base64ToBlob(imgSrc, 'image/jpeg');

		// Send the Blob to the prediction endpoint
		fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/octet-stream',
			},
			body: blob,
		})
			.then((response) => response.json())
			.then((data) => {
				console.log('Prediction Results:', data);
				let hasValidPrediction = false;
				let predictions = [];

				if (data.code === 'BadRequestImageFormat') {
					alert('Image format is not accepted. Please upload a valid image.');
				}

				if (data.predictions.length > 0) {
					// Step 1: Filter predictions with probability > 0.1
					let filteredPredictions = data.predictions.filter((prediction) => prediction.probability > 0.1);

					// Step 2: Accumulate unique tagNames
					let uniqueTagNames = filteredPredictions.reduce((acc, prediction) => {
						if (!acc.includes(prediction.tagName)) {
							acc.push(prediction.tagName);
						}
						return acc;
					}, []);

					// Step 3: Limit to top 5 unique tagNames
					predictions = uniqueTagNames.slice(0, 5);

					if (filteredPredictions && filteredPredictions.length > 0) {
						hasValidPrediction = true;
					}
				}

				if (hasValidPrediction) {
					dashboardModal.querySelector('.c-modal__upload-status--uploading').classList.remove('active');
					dashboardModal.querySelector('.c-modal__upload-status--success').classList.add('active');
					dashboardModal.querySelector('.c-modal__uploader').classList.add('active');

					// Handle buttons
					dashboardModal.querySelector('.c-modal__upload-buttons.active').classList.remove('active');
					dashboardModal.querySelector('.c-modal__upload-buttons--success').classList.add('active');

					qtAnalytics('ai-upload-validation-confirmation-start');

					// Get the predictions
					if (predictions) {
						let predictionList = dashboardModal.querySelector('.c-modal__upload--services .c-qt-icon-select__icons');
						let predictionSubList = dashboardModal.querySelector('.c-modal__upload-sublist');
						predictionList.innerHTML = '';
						let hasAtLeastOneService = false;

						predictions.forEach((prediction) => {
							let iconSelectItem = document.querySelector('.js-qt-icon-select-item[data-tag-names*="' + prediction + '"]');
							if (iconSelectItem) {
								iconSelectItem.classList.add('active');
								let iconSelectItemClone = iconSelectItem.cloneNode(true);

								// If iconSelectItem has data-priority equals no then put it in the sublist
								if (iconSelectItem.dataset.priority === 'no') {
									iconSelectItemClone.classList.remove('active');
									predictionSubList.appendChild(iconSelectItemClone);
								} else {
									predictionList.appendChild(iconSelectItemClone);
								}

								// Add event listener to the cloned element
								iconSelectItemClone.addEventListener('click', function () {
									$('.c-qt-icon-select .js-qt-icon-select-item[data-tag-names*="' + prediction + '"]').toggleClass('active');
								});
								hasAtLeastOneService = true;
							}
						});

						if (!hasAtLeastOneService) {
							// Add no-services class to .c-modal__upload--services
							dashboardModal.querySelector('.c-modal__upload--services').classList.add('no-services');
							// add p to .c-qt-icon-select__icons
							predictionList.innerHTML = `<p>${menaObject.labels.ai.no_services_found}</p>`;
						}
					}
				} else {
					dashboardModal.querySelector('.c-modal__upload-status--uploading').classList.remove('active');
					dashboardModal.querySelector('.c-modal__upload-status--error').classList.add('active');
					dashboardModal.querySelector('.c-modal__upload-buttons--error').classList.add('active');
					dashboardModal.querySelector('.c-modal__uploader').classList.add('failed');
					dashboardModal.querySelector('.c-modal__uploader').classList.remove('active');
					dashboardModal.querySelector('.c-modal__upload--services').classList.remove('no-services');
					dashboardModal.querySelector('.c-modal__upload-buttons--success').classList.remove('active');
					qtAnalytics('ai-upload-validation-error-start');
				}
			})
			.catch((error) => {
				console.error('Error:', error);
				qtAnalytics('ai-upload-validation-error-start');
			});
	}

	// Function for showing/hiding steps where active one gets removed and the next one is shown
	function showStep(step) {
		let activeStep = dashboardModal.querySelector('.c-modal__upload.active');
		activeStep.classList.remove('active');
		dashboardModal.querySelector('.' + step).classList.add('active');

		if (step != 'start') {
			// Add hidden on c-modal__sidebar
			let sidebar = dashboardModal.querySelector('.c-modal__sidebar');
			sidebar.classList.add('hidden');
		} else {
			let sidebar = dashboardModal.querySelector('.c-modal__sidebar');
			sidebar.classList.remove('hidden');
		}
	}

	const goToStartButtons = dashboardModal.querySelectorAll('.js-go-to-start');

	if (goToStartButtons.length > 0) {
		goToStartButtons.forEach((goToStart) => {
			goToStart.addEventListener('click', function () {
				showStep(steps.start);
				resetModal();
			});
		});
	}

	let goToUploading = dashboardModal.querySelector('.js-go-to-uploading');
	if (goToUploading) {
		goToUploading.addEventListener('click', function () {
			showStep(steps.uploading);
			qtAnalytics('ai-upload-validation-submit');
			sendImageForVerification();
		});
	}

	let goToServices = dashboardModal.querySelector('.js-go-to-service-selector');
	if (goToServices) {
		goToServices.addEventListener('click', function () {
			qtAnalytics('ai-upload-validation-confirmation-submit');
			showStep(steps.services);
			qtAnalytics('ai-upload-validation-confirmation-result-start');
		});
	}

	let closeAiModalClasses = dashboardModal.querySelectorAll('.js-close-modal');
	if (closeAiModalClasses) {
		closeAiModalClasses.forEach(function (trigger) {
			trigger.addEventListener('click', function () {
				closeAiModal();
			});
		});
	}

	// Press ESC to close modal
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			closeAiModal();
		}
	});

	let selectManualyTrigger = dashboardModal.querySelector('.js-close-modal-trigger-manual-select');
	if (selectManualyTrigger) {
		selectManualyTrigger.addEventListener('click', function () {
			let iconSelectButton = document.querySelector('.js-qt-next-step[data-next-step="step - 1 - 0 - 1"]');
			if (iconSelectButton) {
				iconSelectButton.click();
				closeAiModal();
			}
		});
	}

	let closeAiModalTrigger = dashboardModal.querySelector('.js-close-modal-trigger-icon-select');
	if (closeAiModalTrigger) {
		closeAiModalTrigger.addEventListener('click', function () {
			let iconSelectButton = document.querySelector('.js-qt-confirm-icon-select');
			if (iconSelectButton) {
				iconSelectButton.click();
				// Find all elements with js-qt-icon-select-item active and get data-service-name from them and store it as string in a variable called selectedServices "service1, service2, service3"
				let selectedServices = '';
				let selectedServicesElements = document.querySelectorAll('.c-modal .js-qt-icon-select-item.active');
				if(selectedServicesElements.length > 0) {
					selectedServicesElements.forEach((element, index) => {
						selectedServices += element.dataset.serviceEngName;
						if(index < selectedServicesElements.length - 1) {
							selectedServices += '| ';
						}
					});
				}
				qtAnalytics('ai-upload-validation-confirmation-result-submit', selectedServices);
			}
			closeAiModal();
		});
	}

	let openAiModalTriggers = document.querySelectorAll('.js-open-ai-dashboard-modal');
	openAiModalTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', function () {
			document.querySelector('#quote-tool').classList.add('is-in-ai-flow');
			qtAnalytics('ai-upload-start');
			openAiModal();
			showStep(steps.start);
		});
	});

	(function () {
		let goToStart = dashboardModal.querySelector('.js-go-to-start');
		if (goToStart) {
			goToStart.addEventListener('click', function () {
				console.log('Go to start');
				showStep(steps.start);
			});
		}
	})();

	dashboardImageUpload.addEventListener('change', function (e) {
		let file = e.target.files[0];
		let formData = new FormData();
		formData.append('file', file);
		qtAnalytics('ai-upload-submit');

		const reader = new FileReader();
		reader.onload = function (e) {
			const imagePreview = dashboardModal.querySelector('#dashboardImagePreview');
			imagePreview.innerHTML = '<img src="' + e.target.result + '" alt="Image preview" style="max-width: 100%; height: auto;"/>';

			// Get file name and size
			let fileName = file.name;
			let fileSize = file.size;

			// Add file name to #uploadFileNameDashboard
			let uploadFileNameDashboard = dashboardModal.querySelector('#uploadFileNameDashboard');
			uploadFileNameDashboard.innerHTML = fileName;

			// Add file size to #uploadFileSize
			let uploadFileSize = dashboardModal.querySelector('#uploadFileSizeDashboard');
			//Convert bytes to KB
			let fileSizeInKB = fileSize / 1024;
			uploadFileSize.innerHTML = fileSizeInKB.toFixed(0) + ' KB';

			// Show the next step
			showStep(steps.verify);
			qtAnalytics('ai-upload-validation-start');
			simulateRandomUpload();
		};
		reader.readAsDataURL(file);
	});
}
